<header class="app-header" [class.impersonating]="isImpersonationAllowed && isImpersonating()">
  <div class="header-left">
    <div class="logo">
       <img src="logo.svg" alt="Plymouth Rock" />
    </div>
  </div>

  <div class="header-right">
    <span class="app-name">{{ appName }}</span>

    @if (isImpersonationAllowed && isImpersonating()) {
      <div class="impersonation-badge">
        <i class="pi pi-eye"></i>
        <span>Impersonating: {{ impersonatedName() }}</span>
        <p-button
          [text]="true"
          [rounded]="true"
          severity="warn"
          icon="pi pi-times"
          size="small"
          (onClick)="stopImpersonating()" />
      </div>
    }

    <p-button
      #userButton
      [text]="true"
      (onClick)="userInfoPopover.toggle($event)">
      <i class="pi pi-user"></i>
      <span class="user-name whitespace-nowrap">{{ userName }}</span>
      <i class="pi pi-chevron-down"></i>
    </p-button>

    <p-popover #userInfoPopover>
      <div class="flex flex-col gap-1 p-2 min-w-[200px] sm:min-w-[250px]">
        <div class="text-base font-semibold text-gray-900">
          {{ userName }}
        </div>
        <div class="text-sm text-gray-600">
          {{ userEmail }}
        </div>

        <hr class="my-1 border-gray-200" />

        @if (isImpersonationAllowed) {
          @if (isImpersonating()) {
            <div class="flex flex-col gap-1 bg-amber-50 rounded-lg p-2 mb-1">
              <span class="text-xs font-medium text-amber-800">Currently impersonating</span>
              <span class="text-sm font-semibold text-amber-900">{{ impersonatedName() }}</span>
              <span class="text-xs text-amber-700">{{ impersonatedLoginId() }}</span>
            </div>
            <p-button
              label="Stop Impersonating"
              severity="warn"
              size="small"
              [fluid]="true"
              [outlined]="true"
              icon="pi pi-times-circle"
              (onClick)="stopImpersonating(); userInfoPopover.hide()" />
          } @else {
            <p-button
              label="Impersonate User"
              severity="secondary"
              size="small"
              [fluid]="true"
              [outlined]="true"
              icon="pi pi-user-edit"
              (onClick)="openImpersonationDialog(userInfoPopover, $event)" />
          }
        }
      </div>
    </p-popover>
  </div>
</header>

@if (isImpersonationAllowed) {
  <app-impersonation-dialog [(visible)]="impersonationDialogVisible" />
}
